import React from 'react'
import { useStyles } from './FeaturedSchoolFiltersView_style'
import { Box, Hidden } from '@material-ui/core'
import TextFilter from '../shared/TextFilter/TextFilter'
import MultipleSelectFilter from '../shared/MultipleSelectFilter/MultipleSelectFilter'
import CollectionHandler from 'assets/CollectionHandler.js'
import FeaturedSchoolFiltersModal from 'modals/FilterModals/FeaturedSchoolFiltersModal/FeaturedSchoolFiltersModal'
import MoreFilters from '../shared/MoreFilters/MoreFilters'
import ResetFilters from '../shared/ResetFilters/ResetFilters'

const FeaturedSchoolFiltersView = (props) => {
    const { schoolCount, debouncedFilterChange, handleFilterChange, filters, setFilters, reset, searchCities, setSearchCities, citiesInput, setCitiesInput, showFeaturedSchoolFiltersModal, setShowFeaturedSchoolFiltersModal } = props
    const classes = useStyles()

    const studyDomainCollection = CollectionHandler.GetSortedCollection('studyDomainCollection')
    const provinceCollection = CollectionHandler.GetSortedCollection('provinceCollection')

    return (
        <>
            <FeaturedSchoolFiltersModal
                showModal={showFeaturedSchoolFiltersModal}
                setShowModal={setShowFeaturedSchoolFiltersModal}
                debouncedFilterChange={debouncedFilterChange}
                handleFilterChange={handleFilterChange}
                filters={filters}
                schoolCount={schoolCount}
                searchCities={searchCities}
                citiesInput={citiesInput}
                setSearchCities={setSearchCities}
                setCitiesInput={setCitiesInput}
                setFilters={setFilters}
                reset={reset}
            />
            <Box className={classes.firstFiltersRow}>
                {/* internship filter */}
                <Box className={classes.searchFieldContainer}>
                    <TextFilter
                        debouncedFilterChange={debouncedFilterChange}
                        handleFilterChange={handleFilterChange}
                        filters={filters}
                        setFilters={setFilters}
                        filterTextId='search_bar.search.school'
                    />
                </Box>
                {/* City filter */}
                <Hidden xsDown>
                    <Box className={classes.studyDomainField}>
                        <MultipleSelectFilter
                            type='province'
                            collection={provinceCollection}
                            filters={filters}
                            setFilters={setFilters}
                            width={350}
                            filterTextId='search_bar.search.province'
                        />
                    </Box>
                </Hidden>
                {/* Study domain filter */}
                <Hidden xsDown>
                    <Box className={classes.studyDomainField}>
                        <MultipleSelectFilter
                            type='studyDomain'
                            collection={studyDomainCollection}
                            filters={filters}
                            setFilters={setFilters}
                            width={350}
                            filterTextId='search_bar.study.field_singular'
                        />
                    </Box>
                </Hidden>
                {/* More filters button */}
                <Box className={classes.moreFiltersButtonContainer}>
                    <MoreFilters
                        setShowModal={setShowFeaturedSchoolFiltersModal}
                        filters={filters}
                    />
                </Box>
                {/* Reset filters button */}
                <Hidden smDown>
                    <Box className={classes.resetFiltersButtonContainer}>
                        <ResetFilters reset={reset} />
                    </Box>
                </Hidden>
            </Box>
        </>
    )
}

export default FeaturedSchoolFiltersView
